import React from 'react';
import { Link } from "react-router-dom";

const DinamicTable = ({ data = [], title = "", tableColumns, addLink = '/', editLink = '/', customLink = '/', filter = { page: 1, pages: 0, limit: 5, isLoading: false, search: '' }, setFilter = () => { }, search = true }) => {

    const handlePageChange = (page) => {
        if (page > 0 && page <= filter?.pages) {
            setFilter({ ...filter, page });
        }
    };

    const handleSearch = (value) => {
        setFilter({ ...filter, page: 1, search: value })
    }

    const render = (value) => {

        if (typeof value === "boolean") {
            return (
                <small className={`badge badge-sm ${value ? "btn-success" : "btn-danger"}`} style={{ padding: "0.3rem 0.5rem" }}>
                    {value ? "true" : "false"}
                </small>
            );
        }
        if (typeof value === "string" && (value?.includes('/api/media/') || value?.includes('/images/'))) {
            return (
                <div className="tyn-media tyn-size-md tyn-circle">
                    <img src={value} alt="" />
                </div>
            );
        }

        if (typeof value === "string" && value?.length > 50) {
            return (
                value?.slice(0, 50)
            );
        }

        return value;
    };

    return (
        <div className="container">
            <div className="tyn-profile d-flex align-items-center justify-content-between px-5 py-4">
                {
                    title?.length && (<div><h3 className="text-center">{title}</h3></div>) || (<></>)
                }

                <div className="right-side d-flex align-items-center">
                    {
                        search && (
                            <div className="tyn-aside-search p-0">
                                <div className="form-group tyn-pill">
                                    <div className="form-control-wrap">
                                        <input type="text" className="form-control form-control-solid" id="search" value={filter?.search} onChange={(e) => handleSearch(e?.target?.value)} placeholder="Search..." />
                                    </div>
                                </div>
                            </div>
                        ) || (<></>)
                    }

                    {
                        addLink?.length > 1 && (<>
                            <div className="separator-line"></div>
                            <div className="tyn-aside-head-tools">
                                <ul className="tyn-list-inline gap gap-3">
                                    <li>
                                        <Link className="btn btn-icon btn-light btn-md btn-pill" to={addLink}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                            </svg>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </>) || (<></>)
                    }
                </div>
            </div>

            <div className="tyn-profile">
                <div className={`tyn-profile-details mt-4 ${!title?.length && " p-0"}`}>
                    {filter?.isLoading ? (
                        <div className="spinner-container d-flex justify-content-center align-items-center">
                            <div
                                className="spinner-border"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>) :
                        (data?.length === 0 ? (
                            <div className="no-data-message d-flex flex-column justify-content-center align-items-center">
                                <p>No data available</p>
                                {addLink?.length > 1 && (<Link className="btn btn-secondary p-2" to={addLink} aria-label="Add New">Add New</Link>) || (<></>)}
                            </div>
                        ) : (
                            <div className="row gy-5">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="user-table">
                                            <thead>
                                                <tr>
                                                    {tableColumns?.map((column, index) => (
                                                        <th key={index}>{column}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data?.map((item, index) => (
                                                        <tr key={item?._id || index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                                                            {Object.keys(item).map((key, index) => (
                                                                <td key={index}>{render(item[key])}</td>
                                                            ))}

                                                            {customLink?.length > 1 && (<>
                                                                <td>
                                                                    <Link className="btn" to={`${customLink}${item?._id}`} >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chat-dots" viewBox="0 0 16 16">
                                                                            <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                                            <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2" />
                                                                        </svg>
                                                                    </Link>
                                                                </td>
                                                            </>) || (<></>)}

                                                            {editLink?.length > 1 && (<>
                                                                <td>
                                                                    <Link className="btn" to={`${editLink}${item?._id}`} >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                                        </svg>
                                                                    </Link>
                                                                </td>
                                                            </>) || (<></>)}
                                                        </tr>
                                                    ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="pagination d-flex justify-content-end" style={{ marginTop: "112px" }}>
                                        <button className="btn btn-light" onClick={() => handlePageChange(1)} disabled={filter?.page === 1}>&lt;&lt;</button>
                                        <button className="btn btn-light" onClick={() => handlePageChange(filter?.page - 1)} disabled={filter?.page === 1}>&lt;</button>

                                        {Array?.from({ length: filter?.pages }, (_, index) => index + 1)
                                            .filter(page => {
                                                return (
                                                    page === 1 ||
                                                    page === filter?.pages ||
                                                    (page >= filter?.page - 2 && page <= filter?.page + 2)
                                                );
                                            })
                                            .map(page => (
                                                <button
                                                    key={page}
                                                    className={`btn btn-light ${filter?.page === page ? 'active' : ''}`}
                                                    onClick={() => handlePageChange(page)}
                                                >
                                                    {page}
                                                </button>
                                            ))}

                                        {filter?.page > 3 && filter?.page < filter?.pages - 2 && (
                                            <span className="btn btn-light disabled">...</span>
                                        )}

                                        <button className="btn btn-light" onClick={() => handlePageChange(filter?.page + 1)} disabled={filter?.page === filter?.pages}>&gt;</button>
                                        <button className="btn btn-light" onClick={() => handlePageChange(filter?.pages)} disabled={filter?.page === filter?.pages}>&gt;&gt;</button>
                                    </div>



                                </div>
                            </div>))}
                </div>
            </div>
        </div >
    );
};

export default DinamicTable;
